import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  createUser,
  getRoles,
  getBrandsForFilter,
  getAccountsForFilter,
  getLocationsForFilter,
} from 'actions/index';
import { Colors } from 'modules/theme';
import { push } from 'modules/history';
import Icon from 'components/Icon';
import H2 from 'components/H2';
import Stepper from 'components/Stepper';
import PropTypes from 'prop-types';
import AlertsForm from 'components/AlertsForm';
import { DeviceTypes } from 'constants/index';
import DetailsForm from './DetailsForm';
import PermissionsForm from './PermissionsForm';

const Container = styled.div`
  box-sizing: border-box;
  max-width: 100%;
  margin: 20px;
  overflow-x: hidden;
  padding-bottom: 24px;
  @media (max-width: 767px) {
    margin: 20px auto;
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (min-width: 768px) {
    margin: 30px;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

const Column = styled.div`
  flex-direction: column;
  align-self: center;
  margin-right: 10px;
  margin-bottom: 10px;
  @media (max-width: 767px) {
    margin-right: 0;
  }
`;

class CreateUser extends Component {
  state = {
    activeTab: 'Details',
    user: {
      brands: [],
      accounts: [],
      locations: [],
    },
  };

  componentDidMount() {
    const { fetchRoles, fetchBrands } = this.props;

    fetchRoles();
    fetchBrands();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.user.role_id !== this.state.user.role_id) {
      const { roles } = this.props;
      const { user } = this.state;
      const userRole = roles.find(e => parseInt(e.value) === parseInt(user.role_id));
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ userRole });
    }
  }

  saveData = (data, nextTab) => {
    const { user, activeTab } = this.state;
    const userUpdated = {
      ...user,
      ...data,
    };

    if (activeTab === 'Permissions') {
      const { submitUser } = this.props;
      submitUser(userUpdated);
    } else {
      this.setState({
        activeTab: nextTab,
        user: userUpdated,
      });
    }
  };

  switchTab = activeTab => {
    this.setState({ activeTab });
  };

  back = backTab => {
    this.setState({
      activeTab: backTab,
    });
  };

  updateUserState = user => {
    this.setState(prevState => ({
      user: {
        ...prevState.user,
        ...user,
      },
    }));
  };

  render() {
    const {
      roles,
      brands,
      accounts,
      locations,
      fetchAccounts,
      fetchLocations,
      fetchBrands,
    } = this.props;

    const { activeTab, user, userRole } = this.state;

    const steps = [{ title: 'Details' }, { title: 'Permissions' }];

    const detailsInitialValues = {
      email: '',
      first_name: '',
      last_name: '',
      phone_number: '',
    };

    const permissionsInitialValues = {
      role_id: '',
      auto_add_to_new_locations: false,
    };

    return (
      <Container>
        <Row>
          <Column>
            <Icon onClick={() => push('/users')} name="chevron-left" color={Colors.blue} />
          </Column>
          <Column>
            <H2 color={Colors.black} style={{ paddingRight: 30 }}>
              Add new user
            </H2>
          </Column>
        </Row>
        <Stepper
          steps={steps}
          activeStep={activeTab}
          onStepClick={idx => this.switchTab(steps[idx].title)}
        />
        {activeTab === 'Details' && (
          <DetailsForm
            initialValues={detailsInitialValues}
            isInitialValid={false}
            onSubmit={this.saveData}
          />
        )}
        {activeTab === 'Permissions' && (
          <>
            <PermissionsForm
              initialValues={permissionsInitialValues}
              isInitialValid={false}
              roles={roles}
              user={user}
              brands={brands}
              accounts={accounts}
              locations={locations}
              fetchAccounts={fetchAccounts}
              fetchLocations={fetchLocations}
              fetchBrands={fetchBrands}
              back={() => this.back('Details')}
              onSubmit={this.saveData}
              updateUserState={this.updateUserState}
            />
            {userRole && (
              <AlertsForm
                back={() => this.back('Details')}
                subtitle="Select all the alerts that would you like to assign to this user."
                onSubmit={this.saveData}
                deviceTypes={DeviceTypes}
                fromUsers={true}
                userRole={userRole}
              />
            )}
          </>
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    roles: state.utils.roles,
    brands: state.brands.listForFilter,
    accounts: state.accounts.listForFilter,
    locations: state.locations.listForFilter,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    submitUser: data => dispatch(createUser(data)),
    fetchRoles: () => dispatch(getRoles()),
    fetchBrands: params => dispatch(getBrandsForFilter(params)),
    fetchAccounts: params => dispatch(getAccountsForFilter(params)),
    fetchLocations: params => dispatch(getLocationsForFilter(params)),
  };
}

CreateUser.propTypes = {
  accounts: PropTypes.array,
  brands: PropTypes.array,
  fetchAccounts: PropTypes.func,
  fetchBrands: PropTypes.func,
  fetchLocations: PropTypes.func,
  fetchRoles: PropTypes.func,
  locations: PropTypes.array,
  roles: PropTypes.array,
  submitUser: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
